import ArrowLeft from "../../assets/icons/Arrow/ArrowLeft";
import ShoppingCartItem from "../../components/ShoppingCartItem/ShoppingCartItem";
import { useAuthModal } from "../../hooks/authContext";
import {
  countQuantityCart,
  getProductById,
} from "../../services/cartShoppingService";
import { getUser } from "../../services/userService";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import { displayNumber, getPrice } from "../../utils/getPrice";
import "./Order.scss";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const _computeTotalPrice = (
  shoppingCart: any,
  products: any,
  reduc: number
) => {
  let price = 0,
    tva = 0;

  shoppingCart.forEach((item: any) => {
    if (products?.[item.productCode]) {
      price +=
        item.quantity *
        Number(getPrice(products[item.productCode].PrixHT, reduc));
      tva +=
        (item.quantity *
          Number(getPrice(products[item.productCode].PrixHT, reduc)) *
          products[item.productCode].TVATaux) /
        100;
    }
  });
  return {
    price,
    tva,
    total: price + tva,
  };
};

const Order = () => {
  const { shoppingCart } = useSelector((state: RootState) => state.cart);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const [products, setProducts] = useState<any>({});
  const { setIsOpen } = useAuthModal();
  const dispatch = useDispatch<AppDispatch>();

  const { user } = useSelector((state: RootState) => state.user);
  const { access_token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [user, access_token, dispatch]);

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  useEffect(() => {
    if (shoppingCart?.length > 0) {
      shoppingCart.forEach((item) => {
        if (!Object.keys(products).includes(item.productCode)) {
          getProductById(item.productCode).then((res) =>
            setProducts((products: any) => ({
              ...products,
              [item.productCode]: res,
            }))
          );
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shoppingCart]);

  const pricing = useMemo(
    () => _computeTotalPrice(shoppingCart, products, user?.discountRate ?? 0),
    [shoppingCart, products, user?.discountRate]
  );

  const goToProduct = ({
    categoryCode,
    subCategoryCode,
    code,
  }: {
    categoryCode?: string;
    subCategoryCode?: string;
    code?: string;
  }) => {
    navigate(`/category-product/${categoryCode}/${subCategoryCode}/${code}`, {
      replace: true,
    });
  };

  return (
    <div className="order">
      <h2>VOTRE PANIER</h2>
      <div>
        <div>
          <p>PRODUITS</p>
          <div className="shopping-cart-items">
            {shoppingCart.map((item, index) => (
              <div key={`${item.productCode}-${index}`}>
                {index > 0 && <div className="border-btm" />}
                <ShoppingCartItem
                  product={products[item.productCode]}
                  quantity={item.quantity}
                  goTo={goToProduct}
                />
              </div>
            ))}
            <div className="button-return">
              <button onClick={() => navigate("/")}>
                <ArrowLeft /> Continuer mes achats
              </button>
            </div>
          </div>
        </div>
        <div>
          <div className="recap-cart">
            <h3>Récapitulatif de la commande</h3>
            <div className="article">
              <span>Articles ({countQuantityCart(shoppingCart)})</span>
            </div>
            <div>
              <span>Total (HT)</span>
              <span>{displayNumber(pricing.price)} €</span>
            </div>
            <div>
              <span>Dont TVA</span>
              <span>{displayNumber(pricing.tva)} €</span>
            </div>
            {user?.discountRate && (
              <div className="delivery">
                Réduction appliquée de {user?.discountRate}%
              </div>
            )}
            <span />
            <div className="separator" />
            <div className="bold">
              <span>Total (TTC)</span>
              <span>{displayNumber(pricing.total)} €</span>
            </div>
            <div>
              <button
                onClick={() =>
                  isAuthenticated ? navigate("/purchase") : setIsOpen(true)
                }
              >
                Commander
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
